import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { LIBRARY_KEY, LIBRARY_UPLOADS_KEY, libraryApi } from '../../api/storage';
import { formatBytes, percent } from '../machine/format';

const WORDS = { running: 'sending', uploaded: 'finishing', done: 'in the library', failed: 'failed', cancelled: 'cancelled' } as const;

/** Models on their way to the library: refreshed every few seconds while one is still moving (doc 75). */
export function LibraryUploads() {
  const queryClient = useQueryClient();
  const uploads = useQuery({
    queryKey: LIBRARY_UPLOADS_KEY, queryFn: libraryApi.uploads,
    refetchInterval: (q) => (q.state.data?.uploads.some((u) => u.status === 'running' || u.status === 'uploaded') ? 3000 : false),
  });
  const doneCount = uploads.data?.uploads.filter((u) => u.status === 'done').length ?? 0;
  useEffect(() => { if (doneCount > 0) void queryClient.invalidateQueries({ queryKey: LIBRARY_KEY }); }, [doneCount, queryClient]);
  const list = uploads.data?.uploads ?? [];
  if (list.length === 0) return null;
  return (
    <div className="library-uploads">
      <h3>On the way</h3>
      <ul>
        {list.map((u) => (
          <li key={u.id}>
            {u.fileName} <span className="muted">from {u.machineName} — {WORDS[u.status]}
              {u.status === 'running' && `, ${percent(u.sentBytes, u.sizeBytes) ?? 0} % of ${formatBytes(u.sizeBytes)}`}</span>
            {u.error && u.status !== 'done' && <span className="form-error"> {u.error}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
